import { render, staticRenderFns } from "./SupportWrapper.vue?vue&type=template&id=555c0a0d&scoped=true&"
import script from "./SupportWrapper.vue?vue&type=script&lang=js&"
export * from "./SupportWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SupportWrapper.vue?vue&type=style&index=0&id=555c0a0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555c0a0d",
  null
  
)

export default component.exports